import "core-js/features/array/flat";
import "core-js/features/array/flat-map";
import "core-js/proposals/iterator-helpers";
import "abortcontroller-polyfill/dist/abortcontroller-polyfill-only";
import "scheduler-polyfill";

// @ts-ignore
import regeneratorRuntime from "regenerator-runtime";

// Перезаписываем regeneratorRuntime, чтобы к Generator-у применился обновленный прототип после iterator-helpers
// @ts-ignore
window.regeneratorRuntime = regeneratorRuntime;
